/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Error_Hint_Chip_RemoveInputs */



/**
* | output |
* | --- |
* | "Remove the error from the next message" |
*
* @param {Canvas_Error_Hint_Chip_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_error_hint_chip_remove = /** @type {((inputs?: Canvas_Error_Hint_Chip_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Error_Hint_Chip_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler aus der nächsten Nachricht entfernen")
	return /** @type {LocalizedString} */ ("Remove the error from the next message")
});